import React, { useState } from 'react';
import Loading from './pages/Loading';
import Homepage from './pages/Homepage.js';
import Header from './layouts/Header';
import Footer from './layouts/Footer';
import About from './pages/About';
import Projects from './pages/Projects';
import ActingReel from './pages/ActingReel';
import AuditionTapes from './pages/AuditionTapes';
import MusicVideos from './pages/MusicVideos';
import Modeling from './pages/Modeling';
import Headshots from './pages/Headshots';
import Contact from './pages/Contact';
import { HashRouter as Router, Route, Switch } from 'react-router-dom';

import { CSSTransition, TransitionGroup } from 'react-transition-group';
import './css/loading.css';
import './css/menu.css';
import './App.css';

//icon
import { library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { faPlayCircle } from '@fortawesome/free-solid-svg-icons';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';

library.add(fab, faTimes, faPlayCircle, faChevronLeft);

function App() {
  const [showMenu, setShowMenu] = useState(false);
  const [selected, setSelected] = useState('home');
  const [openMenu, setOpenMenu] = useState(false);

  return (
    <Router>
      <Route
        render={({ location }) => (
          <>
            <Header
              showMenu={showMenu}
              selected={selected}
              setSelected={setSelected}
              setOpenMenu={setOpenMenu}
              openMenu={openMenu}
            />
            <TransitionGroup>
              <CSSTransition key={location.key} classNames='fade' timeout={500}>
                <Switch location={location}>
                  <Route
                    exact
                    path='/'
                    render={() => <Loading setShowMenu={setShowMenu} />}
                  />
                  <Route
                    path='/homepage'
                    render={() => <Homepage setSelected={setSelected} />}
                  />
                  <Route path='/about' render={() => <About />} />
                  <Route
                    path='/contact'
                    render={() => <Contact openMenu={openMenu} />}
                  />
                  <Route
                    path='/projects'
                    render={() => <Projects openMenu={openMenu} />}
                  />
                  <Route path='/acting-reel' render={() => <ActingReel />} />
                  <Route
                    path='/audition-tapes'
                    render={() => <AuditionTapes />}
                  />
                  <Route path='/music-videos' render={() => <MusicVideos />} />
                  <Route path='/modeling' render={() => <Modeling />} />
                  <Route path='/headshots' render={() => <Headshots />} />
                </Switch>
              </CSSTransition>
            </TransitionGroup>
            <Footer showMenu={showMenu} />
          </>
        )}
      />
    </Router>
  );
}

export default App;
